export const environment = {
  BASE_URL: 'https://maxmotorista-svc.solucoesmaxima.com.br/maxMotoristaService',
  production: true,
  CHAVE_GOOGLE_MAPS: 'AIzaSyBL0jq_t_-GYgps-ZKhuwqKuCuOVkhdhiw',
  SENHA_ADMIN: 'URXI#2638',
  maxHelpScriptUrl: 'https://sabidinho-chat-client-hmg.solucoesmaxima.com.br/maxhelp-wc.js',
  maxInsightsUrl: 'https://maxinsights.solucoesmaxima.com.br'
};
